const state = {
  obj_usuario: ''
};

export default state;